var map = {
	"./ar/translation.json": 2497,
	"./de/translation.json": 2498,
	"./el/translation.json": 2499,
	"./en/translation.json": 2500,
	"./es/translation.json": 2501,
	"./fil/translation.json": 2502,
	"./fr/translation.json": 2503,
	"./hi/translation.json": 2504,
	"./id/translation.json": 2505,
	"./it/translation.json": 2506,
	"./ko/translation.json": 2507,
	"./ms/translation.json": 2508,
	"./nl/translation.json": 2509,
	"./pl/translation.json": 2510,
	"./pt-BR/translation.json": 2511,
	"./pt-PT/translation.json": 2512,
	"./ru/translation.json": 2513,
	"./se/translation.json": 2514,
	"./tr/translation.json": 2515,
	"./uk/translation.json": 2516,
	"./zh/translation.json": 2517
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2496;